<template>
  <el-dialog
    v-bind="$attrs"
    :append-to-body="true"
    :modal="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :custom-class="'image-previewer'"
    :fullscreen="true"
    :show-close="false">
    <div class="image-preview">
      <div class="image-preview-header">
        <span class="image-title" @click="exit"><i class="icon iconfont icon-back back-icon"></i>{{imgName}}</span>
      </div>
      <div class="image-preview-container">
        <div class="image-operates">
          <el-button-group>
            <el-button v-if="false" plain size="mini" icon="el-icon-zoom-in">放大</el-button>
            <el-button v-if="false" plain size="mini" icon="el-icon-zoom-out">缩小</el-button>
            <el-button plain size="mini" icon="el-icon-download" @click="download">下载</el-button>
          </el-button-group>
        </div>
        <div class="image-img">
          <img :src="imgPath" alt="" width="1280px">
        </div>
      </div>
    </div>
  </el-dialog> 
</template>

<script>
export default {
  props: {
    obj: kr.vue.getPropObject(),
    value: kr.vue.getPropObject(),
    title: kr.vue.getPropString()
  },
  computed: {
    imgName() {
      return this.obj && this.obj.value && this.obj.value.title || this.title;
    },
    imgPath() {
      return this.value && this.value.imagePath;
    }
  },
  methods: {
    exit() {
      this.$emit('exit');
    },
    download() {
      this.$emit('download'); 
    }
  }
}
</script>

<style lang="scss">
.el-dialog.is-fullscreen.image-previewer {
  margin-top: 52px !important;

  .el-dialog__body {
    height: calc(100vh - 52px);
    max-height: calc(100vh - 52px);

    .image-preview {
      height: 100%;
      width: 100%;

      .image-preview-header {
        height: 64px;
        border-bottom: 1px solid #e6e9f5;
        display: flex;
        align-items: center;

        .image-title {
          font-family: "PingFangSC-Medium";
          font-size: 18px;
          color: #2e3242;
          text-align: left;
          line-height: 30px;

          .back-icon {
            margin-right: 10px;
            font-size: 20px;
            color: #2e3242;
            cursor: pointer;
            vertical-align: middle;
          }
        }
      }

      .image-preview-container {
        display: flex;
        flex-direction: column;
        height: calc(100% - 64px);

        .image-operates {
          height: 30px;
          display: flex;
          justify-content: flex-end;
          margin-top: 10px;
          margin-bottom: 10px;
          width: 100%;
        }

        .image-img {
          flex: 1;
          width: 100%;
          display: flex;
          align-items: flex-start;
          justify-content: center;
        }
      }
    }
  }
}
</style>
